import i18n from '../../i18n';

export const translations = {
  created: {
    label: i18n.t(`orders-management.cashback-status-created`),
    color: 'bg-primary-subtle text-primary',
  },
  scheduled: {
    label: i18n.t(`orders-management.cashback-status-scheduled`),
    color: 'bg-warning-subtle text-warning',
  },
 
  success: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-success-subtle text-success',
  },
  done: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-success-subtle text-success',
  },
  available: {
    label: i18n.t(`orders-management.cashback-status-available`),
    color: 'bg-success-subtle text-success',
  },
  used: {
    label: i18n.t(`orders-management.cashback-status-used`),
    color: 'bg-success-subtle text-success',
  },
  partially_used: {
    label: i18n.t(`orders-management.cashback-status-partially-used`),
    color: 'bg-success-subtle text-success',
  },
  canceled: {
    label: i18n.t(`orders-management.cashback-status-canceled`),
    color: 'bg-danger-subtle text-danger',
  },
  error: {
    label: i18n.t(`orders-management.cashback-status-error`),
    color: 'bg-danger-subtle text-danger',
  },
  pending: {
    label: i18n.t(`orders-management.cashback-status-pending`),
    color: 'bg-warning-subtle text-warning',
  },
  released: {
    label: i18n.t(`orders-management.cashback-status-released`),
    color: 'bg-success-subtle text-success',
  },
  without_cashback: {
    label: i18n.t(`orders-management.cashback-status-without-cashback`),
    color: 'bg-info-subtle text-info',
  },
  invalid: {
    label: i18n.t(`orders-management.cashback-status-invalid`),
    color: 'custom-invalid',
  },
  abandoned: {
    label: i18n.t(`orders-management.cashback-status-cancelled`),
    color: 'bg-danger-subtle text-danger',
  },
  cancelled: {
    label: i18n.t(`orders-management.cashback-status-cancelled`),
    color: 'bg-danger-subtle text-danger',
  },
  expired: {
    label: i18n.t(`orders-management.cashback-status-expired`),
    color: 'bg-primary-subtle text-light',
  },
  paid: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-primary-subtle text-light',
  },
  delivered: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-primary-subtle text-light',
  },
  refunded: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-primary-subtle text-light',
  },
  partially_refunded: {
    label: i18n.t(`orders-management.cashback-status-done`),
    color: 'bg-primary-subtle text-light',
  },
};
